import React, { useEffect, useRef, useState } from 'react';
import { testimonials } from '../../Data';

import { FaQuoteLeft } from 'react-icons/fa';

const Testimonials = () => {
  const rootRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      id="testimonial"
      ref={rootRef}
      className="relative overflow-hidden bg-gradient-to-b from-[#0b0f17] to-[#070a10] py-20"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-tr from-accent/18 via-emerald-500/10 to-transparent blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative">
        <div
          className={[
            'text-center mb-12 md:mb-16 transition-all duration-700',
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3',
          ].join(' ')}
        >
          <p className="text-xs tracking-[0.22em] uppercase text-gray-400">Testimonials</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white tracking-tight">
            What Clients Say
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Trusted by clients for delivering high-quality frontend solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map(({ img, name, author, description, rating }, idx) => (
            <article
              key={`${name}-${idx}`}
              className={[
                'group rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-8 shadow-soft',
                'transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:border-accent/40',
                'transition-all duration-700',
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3',
              ].join(' ')}
              style={{ transitionDelay: inView ? `${Math.min(idx, 6) * 60}ms` : '0ms' }}
            >
              <div className="space-y-4">
                <FaQuoteLeft className="h-6 w-6 text-white/20" aria-hidden="true" />

                <p className="text-white/85 italic leading-relaxed">
                  “{description}”
                </p>

                <div className="flex items-center gap-1 text-sm text-accent">
                  {[...Array(rating)].map((_, i) => (
                    <span key={i} aria-hidden="true">
                      ★
                    </span>
                  ))}
                  <span className="sr-only">{rating} out of 5 stars</span>
                </div>

                <div className="flex items-center gap-3 pt-2">
                  <img
                    src={img}
                    alt={name}
                    className="w-10 h-10 rounded-full object-cover border border-white/10"
                    loading="lazy"
                    decoding="async"
                  />
                  <div>
                    <p className="font-semibold text-white leading-none">{name}</p>
                    <p className="text-sm text-gray-400 mt-1">{author}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials